import type { PageEventType } from '@unifyapps/defs/types/page';

export function appendEventsIfMissing(
  target: PageEventType[],
  eventsToAdd: readonly PageEventType[],
) {
  for (const event of eventsToAdd) {
    const alreadyPresent = target.some(({ eventType }) => eventType === event.eventType);
    if (alreadyPresent) {
      continue;
    }

    target.push(event);
  }
}
